import styles from './InputMessage.module.scss';

export interface InputMessageProps {
  alertType: 'infoMessage' | 'warningMessage' | 'errorMessage';
  message: string;
}

function InputMessage({alertType, message}: InputMessageProps): JSX.Element {
  return (
    <div
      data-testid="container-input-message"
      className={`${styles.container} ${styles[alertType]}`}
    >
      {message}
    </div>
  );
}

export default InputMessage;
